<template>
  <Drawer :width="AddNewSemicRecipeDrawerOpened ? 1000 : 800" :title="openedMaterial && openedMaterial.model"
    v-model="drawerOpened" class="drawer-body">
    <AddNewSemiRecipeDrawer v-if="AddNewSemicRecipeDrawerOpened" ref="AddNewSemiRecipeDrawer"
      @closeDrawer="closeAddRecipeDrawer" />
    <div v-else class="drawer-content">
      <div class="info-data">
        <div class="sec-title">
          <h2>
            {{ openedMaterial && openedMaterial.model }} -
            {{ openedMaterial && openedMaterial.name }}
          </h2>
        </div>

        <div class="sec-title">
          <div>母液项目</div>
        </div>
        <!-- <RecipeCard
          v-if="prodRecipe"
          :recipe="prodRecipe"
          @click.native="recipedClicked(prodRecipe)"
          :active="prodRecipe._id === selectedRecipe._id"
        /> -->
        <div class="table-wrapper" v-if="semiProduceFactoryList.length > 0">
          <Table :loading="semiItemTableLoading" :columns="semiItemColumns" :data="semiProduceFactoryList" border
            size="small"></Table>
        </div>
        <Alert v-else type="warning" style="margin-top: 12px">暂无母液项目</Alert>

        <div class="sec-title recipeList">
          <div>配方列表</div>
          <Button type="primary" long @click="createNewRecipe" style="margin-top: 12px; width: 100px">创建配方</Button>
        </div>
        <Alert v-if="recipeSemisList.length <= 0" type="warning" style="margin-top: 12px">暂无配方</Alert>
        <RecipeCard v-for="r in recipeSemisList" :recipe="r" :recipeType="recipeType" v-else
          @click.native="recipedClicked(r)" :key="r._id" :active="r._id === selectedRecipe._id" />
      </div>
      <div class="recipe-data">
        <div v-if="selectedRecipe._id">
          <div class="recipe-top">
            <div style="margin-bottom: 12px">
              <div style="display: flex">
                <h1>
                  #{{
                    selectedRecipe.hasOwnProperty("NoId")
                      ? selectedRecipe.NoId
                      : "?"
                  }}
                  -
                </h1>
                <!-- 进入编辑名字状态 -->
                <div v-if="isEdit" class="current-material-name">
                  <Input v-model="selectedRecipe.name" style="line-height: 42px; margin-left: 15px" />
                  <Icon type="ios-checkmark" size="36" style="
                      margin-left: 12px;
                      vertical-align: bottom;
                      cursor: pointer;
                      color: #2db7f5;
                    " @click="saveField(false)" />
                  <Icon type="ios-close" size="36" style="
                      margin-left: 12px;
                      vertical-align: bottom;
                      cursor: pointer;
                      color: #f50;
                    " @click="isEdit = false" />
                </div>
                <!-- 正常状态 -->
                <div v-else class="current-material-name">
                  <h1>
                    {{ selectedRecipe.name }}
                  </h1>
                  <Icon type="ios-create-outline" size="26" style="
                      margin-left: 12px;
                      vertical-align: bottom;
                      cursor: pointer;
                    " @click="editRecipeName(true)" />
                </div>
              </div>
              <div v-if="isEdit">
                <span>含固量（如果是50%则填写50）:&emsp;</span>
                <InputNumber v-model="selectedRecipe.solidContent" /><br />
                <span>A料滴加时间:&emsp;</span>
                <InputNumber v-model="selectedRecipe.dijiaATime" /><br />
                <span>B料滴加时间:&emsp;</span>
                <InputNumber v-model="selectedRecipe.dijiaBTime" /><br />
                <span>C料滴加时间:&emsp;</span>
                <InputNumber v-model="selectedRecipe.dijiaCTime" /><br />
                <span>保温时间:&emsp;</span>
                <InputNumber v-model="selectedRecipe.baowenTime" /><br />
                <span>中和时间:&emsp;</span>
                <InputNumber v-model="selectedRecipe.zhongheTime" /><br />
              </div>
              <div v-else>
                <h3>含固量:&emsp;{{ selectedRecipe.solidContent }}%</h3>
                <h4>A料滴加时间:&emsp;{{ selectedRecipe.dijiaATime }}秒</h4>
                <h4>B料滴加时间:&emsp;{{ selectedRecipe.dijiaBTime }}秒</h4>
                <h4>C料滴加时间:&emsp;{{ selectedRecipe.dijiaCTime }}秒</h4>
                <h4>保温时间:&emsp;{{ selectedRecipe.baowenTime }}秒</h4>
                <h4>中和时间:&emsp;{{ selectedRecipe.zhongheTime }}秒</h4>
              </div>

            </div>
            <div class="copy">
              <Button type="primary" ghost @click="copyRecipe">复制配方</Button>
            </div>
          </div>
          <RecipeTable ref="RecipeTable" />
          <div class="set-recipe">
            <div>将配方#{{ selectedRecipe.NoId }}设为生产（成本核算）配方</div>
            <CheckboxGroup v-model="selectFactoryData" style="margin: 12px 0">
              <Checkbox v-for="item in semiProduceFactoryList" :key="item._id" :label="item._id">{{ item.factory.name }}
              </Checkbox>
            </CheckboxGroup>
            <Button type="primary" ghost long :disabled="this.selectFactoryData.length === 0" @click="setProductRecipe"
              style="width: 120px">设为生产配方</Button>
          </div>
        </div>
        <Alert v-else type="warning">暂无配方</Alert>
      </div>
    </div>
  </Drawer>
</template>

<script>
import _ from "lodash";
import RecipeCard from "../RecipePage/RecipeCard.vue";
import RecipeTable from "../RecipePage/RecipeTable.vue";
import { mapState, mapActions } from "vuex";
import AddNewSemiRecipeDrawer from "../RecipePage/AddNewSemiRecipeDrawer";
import { InputNumber } from "view-design";
export default {
  components: {
    RecipeCard,
    RecipeTable,
    AddNewSemiRecipeDrawer,
  },
  props: [],
  data() {
    return {
      drawerOpened: false,
      openedMaterial: null,
      AddNewSemicRecipeDrawerOpened: false,
      selectedRecipe: {},
      prodRecipe: null,
      semiItemTableLoading: false,
      semiProduceFactoryList: [],
      selectFactoryData: [],
      semiItemColumns: [
        {
          title: "工厂",
          key: "factory",
          align: "left",
          render: (h, params) => {
            return h("div", params.row.factory.name);
          },
        },
        {
          title: "生产配方",
          key: "recipe",
          align: "right",
          render: (h, params) => {
            return h(
              "div",
              "#" +
              (params.row.hasOwnProperty("prodRecipe")
                ? params.row.prodRecipe.NoId
                : "?") +
              " - " +
              (params.row.hasOwnProperty("prodRecipe")
                ? params.row.prodRecipe.name
                : "无配方")
            );
          },
        },
      ],
      isEdit: false,
      recipeType: "",
    };
  },
  methods: {
    ...mapActions({
      getRecipeSemis: "recipeSemi/getRecipeSemisAction",
      getMaterialById: "material/getMaterialByIdAction",
      getRecipeSemisById: "recipeSemi/getRecipeSemisByIdAction",
      updateRecipeSemi: "recipeSemi/updateRecipeSemiAction",
      createRecipeSemi: "recipeSemi/createRecipeSemiAction",
      getSemiProduceFactory: "semiItem/getSemiProduceFactoryAction",
      setSemiItemProdrecipe: "semiItem/setSemiItemProdrecipeAction",
    }),

    async recipedClicked(r) {
      this.selectedRecipe = await this.getRecipeSemisById(r._id);
      this.selectedRecipe.dijiaATime = this.selectedRecipe.dijiaATime || 0;
      this.selectedRecipe.dijiaBTime = this.selectedRecipe.dijiaBTime || 0;
      this.selectedRecipe.dijiaCTime = this.selectedRecipe.dijiaCTime || 0;
      this.$nextTick(() => {
        this.$refs.RecipeTable.loadRecipe(this.selectedRecipe._id, "semi");
      });
      this.selectFactoryData = [];
    },
    resetSelectedRecipe() {
      this.selectedRecipe = {};
    },
    async openDrawer(material, type) {
      this.resetSelectedRecipe();
      this.selectFactoryData = [];
      this.drawerOpened = true;
      this.AddNewSemicRecipeDrawerOpened = false;
      this.openedMaterial = material;
      this.selectedProductId = material._id;
      this.prodRecipe = null;
      if (type) {
        this.recipeType = type;
      }
      try {
        // 1. 获取生产配方
        if (material.recipeSemi) {
          this.prodRecipe = await this.getRecipeSemisById(
            material.recipeSemi._id
          );
        }
        if (this.prodRecipe) {
          this.selectedRecipe = this.prodRecipe;
          this.selectedRecipe.dijiaATime = this.selectedRecipe.dijiaATime || 0;
          this.selectedRecipe.dijiaBTime = this.selectedRecipe.dijiaBTime || 0;
          this.selectedRecipe.dijiaCTime = this.selectedRecipe.dijiaCTime || 0;
        }
        // 2. 获取配方列表
        await this.getRecipeSemis({
          material: material._id,
        });
        // 3. 获取生产工厂
        const semiProduceFactory = await this.getSemiProduceFactory(
          material._id
        );
        this.semiProduceFactoryList = semiProduceFactory;

        if (this.selectedRecipe._id) {
          this.$nextTick(() => {
            this.$refs.RecipeTable.loadRecipe(this.selectedRecipe._id, "semi");
          });
        }
      } catch (error) {
        this.$Message.error(`获取产品失败: ${error}`);
      }
    },
    createNewRecipe() {
      this.AddNewSemicRecipeDrawerOpened = true;
      this.$nextTick(() => {
        this.$refs.AddNewSemiRecipeDrawer.openDrawer(this.openedMaterial);
      });
    },
    async closeAddRecipeDrawer(newRecipe) {
      this.AddNewSemicRecipeDrawerOpened = false;
      this.$nextTick(async () => {
        if (newRecipe) {
          const material = await this.getMaterialById(this.openedMaterial._id);
          this.openDrawer(material);
        }
      });
    },
    async setProductRecipe() {
      const data = {};
      data.semiItemList = this.selectFactoryData;
      data.prodRecipeId = this.selectedRecipe._id;
      try {
        const res = await this.setSemiItemProdrecipe(data);
        for (const semiItem of res) {
          const index = this.semiProduceFactoryList.findIndex(
            (v) => v._id.toString() === semiItem._id.toString()
          );
          this.$set(this.semiProduceFactoryList, index, semiItem);
        }
        this.selectFactoryData = [];
        this.$Message.success("设置成功");
      } catch (error) {
        this.$Message.error("设置失败");
      }
    },
    copyRecipe() {
      this.AddNewSemicRecipeDrawerOpened = true;
      this.$nextTick(() => {
        this.$refs.AddNewSemiRecipeDrawer.openDrawer(
          this.openedMaterial,
          this.selectedRecipe
        );
      });
    },
    async saveField(flag) {
      this.isEdit = flag;
      await this.updateRecipeSemi({
        id: this.selectedRecipe._id,
        data: {
          name: this.selectedRecipe.name,
          solidContent: this.selectedRecipe.solidContent,
          dijiaATime: this.selectedRecipe.dijiaATime,
          dijiaBTime: this.selectedRecipe.dijiaBTime,
          dijiaCTime: this.selectedRecipe.dijiaCTime,
          baowenTime: this.selectedRecipe.baowenTime,
          zhongheTime: this.selectedRecipe.zhongheTime
        },
      });
    },
    editRecipeName() {
      this.isEdit = true;
    },
  },
  computed: {
    ...mapState({
      recipeSemisList: (state) => state.recipeSemi.recipeSemiList,
    }),
  },
};
</script>

<style scoped lang="stylus">
.info-data
  width 300px
  padding-right 20px
  height 100%
  float left
  overflow-y auto

  > .sec-title ~ .sec-title
    margin-top 16px

  .sec-title
    margin-bottom 8px

.table-wrapper
  width 100%

.recipeList
  display flex
  justify-content space-between
  align-items center

.recipe-data
  margin-left 16px
  height 100%
  width 445px
  float left
  overflow-y auto

.recipe-top
  display flex
  justify-content space-between
  align-items flex-end

  .copy
    padding-bottom 16px

.set-recipe
  margin-top 20px

.sec-title
  width 100%
  font-weight 800

.current-material-name
  display flex
</style>
